// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"ReportDetailView_details__topBarContainer__lfHZ1"};